export const FEATURE_FLAG_KEYS = [
    'geolocationBannerActions',
    'parkingDiscountBanner',
    'parkingPackages',
    'communityParkings',
    'partnersIntegration',
    'gates',
];
